import { useAbility } from '@cast/shared-ability-data-access';

import { useCluster } from '@cast/shared-cluster-context-data-access';

export const useStorageOptimizationAbilities = () => {
  const { cluster } = useCluster();

  const [
    canViewNodeLevelStop,
    canViewStopPersistentVolumes,
    canViewStopConfig,
    canViewStopPvPolicies,
    canViewStopEvents,
  ] = useAbility().canMany(
    [
      ['view', 'ClusterNodeAutoscalerStop'],
      ['view', 'ClusterStopPersistentVolumes'],
      ['view', 'ClusterStopConfig'],
      ['view', 'ClusterStopPvPolicies'],
      ['view', 'ClusterStopEvents'],
    ],
    { clusterId: cluster.id }
  );

  return {
    canViewNodeLevelStop,
    canViewStopPersistentVolumes,
    canViewStopConfig,
    canViewStopPvPolicies,
    canViewStopEvents,
    canViewClusterLevelStop:
      canViewStopPersistentVolumes ||
      canViewStopConfig ||
      canViewStopPvPolicies ||
      canViewStopEvents,
  };
};
